module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData", "$cookies", "$http",
        function (Service, $q, brand, brandConfig, session, sessionData, $cookies, $httpProvider) {

            new Service({
                name: 'architecture',
                group:"eprsvc",
                url:"/eprweb/src/directives/common/architecture.json",
                headers: {},
                submitSearch: function() {
                    return this.get();
                }
            });
        }]);
};